import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MapContainer, TileLayer, CircleMarker, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import CarteInstallations from './CarteInstallations';

const ECO_GLOW_ICON = L.divIcon({
  className: "",
  html:
    '<div style="position:relative;width:40px;height:44px;">' +
      '<div style="position:absolute;left:9px;top:5px;width:22px;height:22px;background:#2F6BEB;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 0 14px 3px rgba(47,107,235,0.75),0 3px 5px rgba(0,0,0,0.25);"></div>' +
      '<div style="position:absolute;left:16px;top:12px;width:8px;height:8px;background:#ffffff;border-radius:50%;"></div>' +
    '</div>',
  iconSize: [40, 44],
  iconAnchor: [20, 32],
  popupAnchor: [0, -28]
});
import { 
  Users, 
  FileText, 
  TrendingUp,
  Trophy,
  TrendingDown, 
  Zap,
  Euro,
  Calendar,
  Sun,
  Battery,
  MapPin,
  Phone,
  Mail,
  Clock,
  CheckCircle,
  AlertCircle,
  Plus,
  Target
} from 'lucide-react';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// ------------------------------------------------------------
// Habillage v2 (20/09/2026) — design carte arrondie / pastels
// ------------------------------------------------------------
const CSS_ADMIN = `
.dbadmin { --txt:#0F172A; --txt2:#64748B; --line:#EEF2F7;
  --ombre:0 1px 3px rgba(15,23,42,.05), 0 10px 30px rgba(15,23,42,.05);
  font-family:'Inter',-apple-system,sans-serif; color:var(--txt); }
.dbadmin * { box-sizing:border-box; }
.dbadmin .carte { background:#fff; border-radius:20px; box-shadow:var(--ombre); }
.dbadmin .kpis { display:grid; grid-template-columns:repeat(4,1fr); gap:18px; }
@media (max-width:1100px){ .dbadmin .kpis { grid-template-columns:repeat(2,1fr); } }
@media (max-width:640px){ .dbadmin .kpis { grid-template-columns:1fr; } }
.dbadmin .kpi { padding:20px 22px 16px; overflow:hidden; }
.dbadmin .kpi .haut { display:flex; align-items:center; gap:12px; margin-bottom:16px; }
.dbadmin .ico { width:44px; height:44px; border-radius:14px; display:flex; align-items:center; justify-content:center; flex:none; }
.dbadmin .kpi .nomk { font-size:11px; font-weight:600; letter-spacing:1.2px; text-transform:uppercase; color:var(--txt2); }
.dbadmin .kpi .bas { display:flex; align-items:flex-end; gap:14px; }
.dbadmin .kpi .valwrap { flex:none; }
.dbadmin .kpi .val { font-size:30px; font-weight:800; letter-spacing:-1px; line-height:1; white-space:nowrap; }
.dbadmin .kpi .sousk { font-size:12.5px; color:var(--txt2); margin-top:7px; }
.dbadmin .kpi .zone-spark { flex:1; min-width:0; height:46px; }
.dbadmin .tete { display:flex; align-items:center; gap:14px; padding:22px 26px 0; }
.dbadmin .tete h2 { font-size:19px; font-weight:700; letter-spacing:-.3px; margin:0; }
.dbadmin .tete .sous { font-size:13px; color:var(--txt2); margin-top:2px; }
.dbadmin .vague { display:block; width:100%; height:150px; margin-top:8px; }
.dbadmin .triple { display:grid; grid-template-columns:repeat(3,1fr); padding:8px 10px 24px; }
.dbadmin .triple > div { text-align:center; padding:0 14px; }
.dbadmin .triple > div + div { border-left:1px solid var(--line); }
.dbadmin .triple .gros { font-size:26px; font-weight:800; letter-spacing:-.8px; }
.dbadmin .triple .pt { font-size:13px; color:var(--txt2); margin-top:6px; }
.dbadmin .grid2 { display:grid; grid-template-columns:1fr 1fr; gap:18px; }
@media (max-width:1000px){ .dbadmin .grid2 { grid-template-columns:1fr; } }
.dbadmin .lignes { padding:8px 10px 12px; }
.dbadmin .ligne { display:flex; align-items:center; gap:14px; margin:0 8px; padding:14px 8px; border-top:1px solid var(--line); }
.dbadmin .lignes .ligne:first-child { border-top:none; }
.dbadmin .avatar { width:52px; height:52px; border-radius:50%; background:linear-gradient(135deg,#DBEAFE,#F0F7FF); color:#2563EB; display:flex; align-items:center; justify-content:center; font-weight:700; font-size:17px; flex:none; }
.dbadmin .numrond { width:46px; height:46px; border-radius:50%; background:linear-gradient(135deg,#DBEAFE,#F5F9FF); color:#2563EB; display:flex; align-items:center; justify-content:center; font-weight:700; font-size:16px; flex:none; }
.dbadmin .qui { flex:1; min-width:0; }
.dbadmin .qui .nomq { font-size:15.5px; font-weight:700; }
.dbadmin .qui .meta { display:flex; gap:16px; font-size:12.5px; color:var(--txt2); margin-top:4px; align-items:center; flex-wrap:wrap; }
.dbadmin .qui .meta span { display:flex; align-items:center; gap:5px; }
.dbadmin .chev { width:36px; height:36px; border-radius:50%; border:1px solid var(--line); background:#fff; display:flex; align-items:center; justify-content:center; color:var(--txt2); font-size:16px; font-weight:600; flex:none; }
.dbadmin .dro { text-align:right; flex:none; }
.dbadmin .dro .vert { font-size:21px; font-weight:800; color:#16A34A; }
.dbadmin .dro .pt { font-size:11.5px; color:var(--txt2); margin-top:2px; }
.dbadmin .videc { padding:36px; text-align:center; color:var(--txt2); font-size:13.5px; }
`;

const rndAdm = (seed) => { let s = seed * 131 + 7; return () => { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; }; };

// Petite courbe décorative montante (comme la maquette)
const SparkAdm = ({ color, seed }) => {
  const W = 160, H = 46, n = 12;
  const r = rndAdm(seed);
  const pts = [];
  for (let i = 0; i < n; i++) {
    const prog = i / (n - 1);
    pts.push([prog * W, H - 6 - (prog * 0.55 + r() * 0.3) * (H - 12)]);
  }
  const d = 'M' + pts.map(p => p[0].toFixed(1) + ',' + p[1].toFixed(1)).join(' L');
  const gid = 'dbadm_g' + seed;
  return (
    <svg className="spark" width="100%" height="46" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none">
      <defs><linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor={color} stopOpacity=".30" /><stop offset="1" stopColor={color} stopOpacity="0" />
      </linearGradient></defs>
      <path d={`${d} L${W},${H} L0,${H} Z`} fill={`url(#${gid})`} />
      <path d={d} fill="none" stroke={color} strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
};

// Grande vague décorative du bloc Performance
const VagueAdm = () => (
  <svg className="vague" viewBox="0 0 1200 150" preserveAspectRatio="none">
    <defs>
      <linearGradient id="dbadm_v1" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#93C5FD" stopOpacity=".35" /><stop offset="1" stopColor="#93C5FD" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="dbadm_v2" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#BFDBFE" stopOpacity=".35" /><stop offset="1" stopColor="#BFDBFE" stopOpacity="0" />
      </linearGradient>
    </defs>
    <path d="M0,95 C150,45 280,110 430,85 C580,60 700,115 860,90 C1010,68 1100,40 1200,28 L1200,150 L0,150 Z" fill="url(#dbadm_v1)" />
    <path d="M0,115 C180,80 320,130 480,105 C640,80 780,130 940,105 C1080,85 1140,70 1200,60 L1200,150 L0,150 Z" fill="url(#dbadm_v2)" />
    <circle cx="1188" cy="26" r="5" fill="#2563EB" />
  </svg>
);

const KpiAdm = ({ ico, icoBg, nom, val, sous, sparkColor, seed }) => (
  <div className="carte kpi">
    <div className="haut">
      <span className="ico" style={{ background: icoBg }}>{ico}</span>
      <span className="nomk">{nom}</span>
    </div>
    <div className="bas">
      <div className="valwrap">
        <div className="val">{val}</div>
        <div className="sousk">{sous}</div>
      </div>
      <div className="zone-spark"><SparkAdm color={sparkColor} seed={seed} /></div>
    </div>
  </div>
);

const InitialesAdm = (prenom, nom) =>
  ((prenom || '').charAt(0) + (nom || '').charAt(0)).toUpperCase() || '–';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [recentClients, setRecentClients] = useState([]);
  const [recentDevis, setRecentDevis] = useState([]);
  const [loading, setLoading] = useState(true);

  const [installations, setInstallations] = useState([]);

  const prospects = stats?.overview?.total_prospects || 0;
const clients = (stats?.by_status?.["CLIENT INSTALLÉ"] || 0) + (stats?.by_status?.["Client installé"] || 0);

const prospectsMois = stats?.overview?.total_prospects || 0;
const clientsMois = (stats?.by_status?.["CLIENT INSTALLÉ"] || 0) + (stats?.by_status?.["Client installé"] || 0);

const tauxTransformation =
  prospectsMois > 0 ? ((clientsMois / prospectsMois) * 100).toFixed(1) : 0;

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    try {
      const [statsResponse, clientsResponse, devisResponse] = await Promise.all([
        axios.get(`${API}/stats`),
        axios.get(`${API}/stats/commercials`),
        axios.get(`${API}/stats/statuses`)
      ]);

      setStats(statsResponse.data.data);
      
      // Charger les clients installés pour la carte
      const CP_COORDS = {
        "01":[46.2057,5.2256],"02":[49.5641,3.6178],"03":[46.5658,3.3324],"04":[44.0921,6.2357],
        "05":[44.5594,6.0796],"06":[43.7102,7.2620],"07":[44.7349,4.5994],"08":[49.7719,4.7197],
        "09":[42.9637,1.6045],"10":[48.2973,4.0744],"11":[43.2130,2.3491],"12":[44.3496,2.5736],
        "13":[43.2965,5.3698],"14":[49.1829,-0.3707],"15":[44.9259,2.4407],"16":[45.6484,0.1562],
        "17":[46.1591,-1.1520],"18":[47.0810,2.3987],"19":[45.2671,1.7714],"20":[42.1500,9.1000],
        "21":[47.3220,5.0415],"22":[48.5141,-2.7653],"23":[46.1714,1.8714],"24":[45.1840,0.7218],
        "25":[47.2380,6.0243],"26":[44.9334,4.8924],"27":[49.0270,1.1508],"28":[48.4439,1.4895],
        "29":[47.9960,-4.0973],"30":[43.8367,4.3601],"31":[43.6047,1.4442],"32":[43.6463,0.5855],
        "33":[44.8378,-0.5792],"34":[43.6119,3.8772],"35":[48.1173,-1.6778],"36":[46.8119,1.6918],
        "37":[47.3941,0.6848],"38":[45.1885,5.7245],"39":[46.6753,5.5544],"40":[43.8907,-0.4990],
        "41":[47.5861,1.3359],"42":[45.4397,4.3872],"43":[45.0430,3.8850],"44":[47.2184,-1.5536],
        "45":[47.9029,1.9093],"46":[44.4475,1.4413],"47":[44.2034,0.6164],"48":[44.5180,3.5006],
        "49":[47.4784,-0.5632],"50":[49.1158,-1.0890],"51":[48.9566,4.3637],"52":[48.1117,5.1389],
        "53":[48.0698,-0.7700],"54":[48.6921,6.1844],"55":[48.7710,5.1614],"56":[47.6582,-2.7608],
        "57":[49.1193,6.1757],"58":[46.9896,3.1570],"59":[50.6292,3.0573],"60":[49.4295,2.0809],
        "61":[48.4306,0.0915],"62":[50.2910,2.7775],"63":[45.7772,3.0870],"64":[43.2951,-0.3708],
        "65":[43.2328,0.0782],"66":[42.6887,2.8948],"67":[48.5734,7.7521],"68":[48.0794,7.3585],
        "69":[45.7640,4.8357],"70":[47.6216,6.1556],"71":[46.3069,4.8286],"72":[48.0061,0.1996],
        "73":[45.5646,5.9178],"74":[45.8992,6.1294],"75":[48.8566,2.3522],"76":[49.4432,1.0993],
        "77":[48.5421,2.6601],"78":[48.8014,2.1301],"79":[46.3239,-0.4646],"80":[49.8941,2.2958],
        "81":[43.9298,2.1480],"82":[44.0181,1.3550],"83":[43.1242,5.9280],"84":[43.9493,4.8055],
        "85":[46.6705,-1.4269],"86":[46.5802,0.3404],"87":[45.8336,1.2611],"88":[48.1744,6.4513],
        "89":[47.7982,3.5734],"90":[47.6379,6.8628],"91":[48.6238,2.4290],"92":[48.8924,2.2069],
        "93":[48.9106,2.4397],"94":[48.7904,2.4556],"95":[49.0518,2.0938],"97":[16.2650,-61.5510]
      };
      const clientsData = statsResponse.data.data;
      try {
        const STATUTS = ["CLIENT%20INSTALL%C3%89", "Client%20install%C3%A9"];
        let prospects = [];
        for (const st of STATUTS) {
          try {
            const r = await axios.get(API + "/prospects?status=" + st + "&limit=100", {
              headers: { Authorization: "Bearer " + localStorage.getItem("token") }
            });
            prospects = prospects.concat(r.data?.data?.prospects || []);
          } catch (err) {}
        }
        const jitter = (s) => { let h = 0; const str = String(s || ''); for (let k = 0; k < str.length; k++) h = (h * 31 + str.charCodeAt(k)) % 100000; return (h / 100000 - 0.5) * 0.08; };
        const mapped = prospects.map((p) => {
          const dep = (p.code_postal || '').substring(0, 2);
          const coords = CP_COORDS[dep] || [46.603354, 1.888334];
          return {
            id: p.id,
            nom: p.prenom + " " + p.nom,
            code_postal: p.code_postal,
            produit: p.puissance_installation || 'Panneaux photovoltaïques',
            lat: coords[0] + jitter((p.id || '') + 'a'),
            lng: coords[1] + jitter((p.id || '') + 'b')
          };
        });
        setInstallations(mapped);
      } catch(e) {
        console.log('Erreur chargement installations:', e);
      }
      const commerciaux = clientsResponse.data?.data?.commercials || [];
      setRecentClients(commerciaux.sort((a, b) => b.gagnes - a.gagnes).slice(0, 5));
      setRecentDevis(devisResponse.data?.data?.distribution?.slice(0, 5) || []);
    } catch (error) {
      console.error('Erreur lors du chargement du dashboard:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      prospect: { label: 'Prospect', class: 'badge-info' },
      devis: { label: 'Devis', class: 'badge-warning' },
      client: { label: 'Client', class: 'badge-success' },
      installe: { label: 'Installé', class: 'badge-success' },
      brouillon: { label: 'Brouillon', class: 'badge-secondary' },
      envoye: { label: 'Envoyé', class: 'badge-warning' },
      accepte: { label: 'Accepté', class: 'badge-success' },
      refuse: { label: 'Refusé', class: 'badge-danger' }
    };
    return badges[status] || { label: status, class: 'badge-secondary' };
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="dbadmin space-y-6 fade-in">
      <style>{CSS_ADMIN}</style>

      {/* ============ KPI ============ */}
      <div className="kpis">
        <KpiAdm ico={<Users style={{ width: 20, height: 20, color: '#2563EB' }} />} icoBg="#E7EDFF"
          nom="Prospects" val={stats?.overview?.total_prospects || 0} sous="au total"
          sparkColor="#3B82F6" seed={1} />
        <KpiAdm ico={<FileText style={{ width: 20, height: 20, color: '#7C5CFC' }} />} icoBg="#EFEBFF"
          nom="Devis envoyés" val={stats?.by_status?.["Devis envoyé"] || 0} sous="envoyés"
          sparkColor="#8B5CF6" seed={2} />
        <KpiAdm ico={<Users style={{ width: 20, height: 20, color: '#16A34A' }} />} icoBg="#E5F8EE"
          nom="Clients installés" val={(stats?.by_status?.["CLIENT INSTALLÉ"] || 0) + (stats?.by_status?.["Client installé"] || 0)} sous="installés"
          sparkColor="#22C55E" seed={3} />
        <KpiAdm ico={<Euro style={{ width: 20, height: 20, color: '#2563EB' }} />} icoBg="#E7F2FE"
          nom="CA total" val={(stats?.ca_total || 0).toLocaleString('fr-FR') + ' €'} sous="au total"
          sparkColor="#3B82F6" seed={4} />
      </div>

      {/* ============ PERFORMANCE ============ */}
      <div className="carte">
        <div className="tete">
          <span className="ico" style={{ background: '#E7EDFF' }}><Target style={{ width: 20, height: 20, color: '#2563EB' }} /></span>
          <div>
            <h2>Performance</h2>
            <div className="sous">Vue d'ensemble de votre activité</div>
          </div>
        </div>
        <VagueAdm />
        <div className="triple">
          <div><div className="gros">{prospectsMois}</div><div className="pt">Prospects</div></div>
          <div><div className="gros">{clientsMois}</div><div className="pt">Clients installés</div></div>
          <div><div className="gros">{tauxTransformation} %</div><div className="pt">Taux de conversion</div></div>
        </div>
      </div>

      {/* ============ TOP VENTES / TOP COMMERCIAUX ============ */}
      <div className="grid2">
        <div className="carte">
          <div className="tete">
            <span className="ico" style={{ background: '#E7EDFF' }}><Trophy style={{ width: 20, height: 20, color: '#2563EB' }} /></span>
            <div>
              <h2>Top ventes</h2>
              <div className="sous">Le commercial avec les meilleures performances</div>
            </div>
          </div>
          {recentClients.length > 0 ? (
            <div className="lignes">
              {recentClients.map((client) => (
                <div className="ligne" key={client.id}>
                  <div className="avatar">{InitialesAdm(client.prenom, client.nom)}</div>
                  <div className="qui">
                    <div className="nomq">{client.prenom} {client.nom}</div>
                    <div className="meta">
                      {client.ville ? <span><MapPin style={{ width: 13, height: 13 }} />{client.ville}</span> : null}
                      {client.telephone ? <span><Phone style={{ width: 13, height: 13 }} />{client.telephone}</span> : null}
                    </div>
                  </div>
                  <div className="chev">›</div>
                </div>
              ))}
            </div>
          ) : (
            <div className="videc">Aucun commercial pour le moment</div>
          )}
        </div>

        <div className="carte">
          <div className="tete">
            <span className="ico" style={{ background: '#E7EDFF' }}><Users style={{ width: 20, height: 20, color: '#2563EB' }} /></span>
            <div>
              <h2>Top commerciaux</h2>
              <div className="sous">Classement par nombre de clients installés</div>
            </div>
          </div>
          {recentClients.length > 0 ? (
            <div className="lignes">
              {recentClients.map((commercial, index) => (
                <div className="ligne" key={commercial.id}>
                  <div className="numrond">{index + 1}</div>
                  <div className="qui">
                    <div className="nomq">{commercial.nom}</div>
                    <div className="meta"><span>{commercial.total_assigned} prospects assignés</span></div>
                  </div>
                  <div className="dro">
                    <div className="vert">{commercial.gagnes}</div>
                    <div className="pt">clients installés</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="videc">Aucun commercial pour le moment</div>
          )}
        </div>
      </div>

      {/* Carte France */}
      <CarteInstallations />

    </div>
  );
};

export default Dashboard;